module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('upload', {
    attrs: {
      "action": _vm.action,
      "token": _vm.token,
      "multiple": _vm.multiple,
      "accept": _vm.accept
    },
    on: {
      "on-upload": _vm.uploadFile,
      "on-error": _vm.uploadErr,
      "on-progress": _vm.progress
    }
  }, [_c('template', {
    slot: "form"
  }), _vm._v(" "), _c('template', {
    slot: "picker"
  }, [_c('span', {
    staticClass: "btn"
  }, [_vm._v("上传图片")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("上传结果")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "result"
    }
  }, [_c('p', [_vm._v("hash: " + _vm._s(_vm.hashes))]), _vm._v(" "), _c('p', [_vm._v("key: " + _vm._s(_vm.keys))])]), _vm._v(" "), _c('div', _vm._l((_vm.hashes), function(item) {
    return _c('img', {
      key: item,
      staticClass: "viewimg",
      attrs: {
        "src": item,
        "alt": "hashes"
      }
    })
  })), _vm._v(" "), _c('div', _vm._l((_vm.keys), function(item) {
    return _c('img', {
      key: item,
      staticClass: "viewimg",
      attrs: {
        "src": item,
        "alt": "keys"
      }
    })
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadMsg.length),
      expression: "uploadMsg.length"
    }],
    staticClass: "block",
    attrs: {
      "id": "ajaxErr"
    }
  }, [_c('h4', [_vm._v("uploadMsg: ")]), _vm._v(" "), _vm._l((_vm.uploadMsg), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(item))])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0451e830","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 5
// module chunks = 0